module.exports = __webpack_public_path__ + "static/media/IMG_1060_Small.fd9be6b4.jpg";